/**
 * Policy type discriminator values
 */
export enum PolicyTypeEnum {
	WORKING_PERIODS = 'working_periods',
	FUEL = 'fuel',
	RENTAL_DURATION = 'rental_duration',
	MINIMUM_RENTAL = 'minimum_rental',
	DRIVER_ELIGIBILITY = 'driver_eligibility',
	DEPOSIT = 'deposit',
	LATE_RETURN = 'late_return',
	MILEAGE = 'mileage',
}
